import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import {
  SORT_TIMESTAMP,
  SORT_USER,
  SORT_TRANSPORTER,
  SORT_RFID,
  SORT_UWB,
  SORT_CHARGING,
  SORT_LIFTLOG,
} from "../Containers/TransporterCheck/TransporterCheck";
import { formatDateOnly } from "utility.js";

const STORE_TRANSPORTER_CHECK = "transportercheck";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class TransporterCheckStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable uploading = false;
  @action setUploading(value = true) {
    this.uploading = value;
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      //console.log(item);
      for (const v of ["LiftLog", "Charging", "Rfid", "Uwb"]) {
        item[`${v}Name`] = item[v] ? "Igen" : "Nem";
      }
      item.FilterField = (item.Transporter + " " + item.UserName).toLowerCase();
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable from = new Date();
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDateOnly(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDateOnly(this.to);
  }

  @observable showTerminated = false;
  @action changeShowTerminated() {
    this.showTerminated = !this.showTerminated;
  }

  @observable searchtext = "";
  @action setSearchText(value) {
    this.searchtext = value;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable typeOptions = [
    { value: null, label: "Összes" },
    { value: "uzem", label: "Üzemben maradt / nincs tárhelye" },
    { value: "szallitas", label: "Szállítás alatt" },
    { value: "missplaced", label: "Feltételezett hibás tárhelyen van" },
    { value: "noRfid", label: "RFID olvasás nélkül megadott pozícióval" },
  ];
  @observable typeOption = this.typeOptions[0];
  @action setTypeOption(value) {
    this.typeOption = JSON.parse(JSON.stringify(value));
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @computed get filteredItems() {
    console.log("filter", this.search, this.typeOption);
    if (!this.search && this.typeOption.value === null) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        if (
          this.typeOption.value !== null &&
          item.Type !== this.typeOption.value
        ) {
          return false;
        }

        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }

        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems =
      [SORT_USER, SORT_TRANSPORTER].indexOf(this.sortField) > -1
        ? this.filteredItems.slice().sort((a, b) => {
            if (!a[this.sortField]) return -1;
            if (!b[this.sortField]) return 1;
            return a[this.sortField]
              ? a[this.sortField].localeCompare(b[this.sortField])
              : -1;
          })
        : this.filteredItems.slice().sort((a, b) => {
            const v1 = parseInt(a[this.sortField]);
            const v2 = parseInt(b[this.sortField]);
            if (v1 === v2) return 0;
            return v1 > v2 ? 1 : -1;
          });

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems.slice(
      this.pager.firstShownItem - 1,
      this.pager.lastShownItem
    );
  }

  @observable palletHistory;
  @action setTransporterHistory(value) {
    this.palletHistory = value;
  }

  @observable sealnums = [];
  @action setSealnums(value) {
    this.sealnums = value;
  }

  @observable selectedTransporterId = null;
  @action setSelectedTransporterId(value) {
    this.selectedTransporterId = value;
  }
  @computed get selectedTransporter() {
    const pallets = JSON.parse(JSON.stringify(this.items));
    const pallet = pallets.find((p) => p.Id == this.selectedTransporterId);
    return pallet;
  }
}

export { TransporterCheckStore, STORE_TRANSPORTER_CHECK, SORT_ASC, SORT_DESC };
